import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useStream } from "../PopularVideoSection/StreamContext";
import { JWPImage, JWPImageSize } from "../../JWPImage";
export const TvCover = ()=>{
    const stream = useStream();
    if (!stream) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "absolute top-0 left-0 w-full h-full",
        children: [
            /*#__PURE__*/ _jsx(JWPImage, {
                src: stream.currentlyPlayingMediaSummary.item.image,
                alt: stream.currentlyPlayingMediaSummary.item.title,
                size: JWPImageSize.Background,
                fill: true,
                style: {
                    objectFit: "cover"
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "absolute top-0 left-0 w-full h-full bg-gradient-to-b from-black/30 to-black/60"
            })
        ]
    });
};
